// extracted by mini-css-extract-plugin
module.exports = {"ratingStarsContainer":"StarsRating_ratingStarsContainer__xPvKU","starContainer":"StarsRating_starContainer__6r1B3"};